import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useMixpanelIsConnected(tenant: number) {
  return useQuery<boolean>({
    queryKey: ['mixpanel', tenant],
    queryFn: async () => {
      const { data } = await axios.get(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/mixpanel`
      );

      return !!data?._id;
    },
  });
}
